const t = {
  width: "auto",
  minWidth: "auto",
  maxWidth: ["95%", "480px"],
  px: 5,
  borderRadius: "xxl"
}, o = {
  toast: t
};
export {
  o as toastsTheme
};
